var _rect, _rect2, _path, _g, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_409)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#43B17E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#paint0_linear_117_409)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_409",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 10,
    width: 23,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9 10.7117H44.9V38.1H30.8V18.9L26.3 18.1H22.9V10.7117Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3 13.5H25.5V36.2H27.2V21.1C27.2 18.449 29.349 16.3 32 16.3H34.3V13.5Z",
    fill: "url(#paint1_linear_117_409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2 36.2H41.5V21.4C41.5 15.8771 37.0229 11.4 31.5 11.4H31.2V11.4184C36.2224 11.7282 40.2 15.8996 40.2 21V36.2Z",
    fill: "url(#paint2_linear_117_409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1 21C21.1 15.7533 25.3533 11.5 30.6 11.5C35.8467 11.5 40.1 15.7533 40.1 21V36.1H35.6V20.95C35.6 18.1057 33.2943 15.8 30.45 15.8C27.6057 15.8 25.3 18.1057 25.3 20.95V36.1H21.1V21Z",
    fill: "url(#paint3_linear_117_409)",
    stroke: "url(#paint4_linear_117_409)",
    strokeWidth: 0.2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 13.5H15.2L9.20001 17.5V36.2H12.5V21.1C12.5 18.449 14.649 16.3 17.3 16.3H18.8V13.5Z",
    fill: "url(#paint5_linear_117_409)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 36.2H26.8V21.4C26.8 15.8771 22.3228 11.4 16.8 11.4H16.5V11.4184C21.5224 11.7282 25.5 15.8996 25.5 21V36.2Z",
    fill: "url(#paint6_linear_117_409)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39999 21C6.39999 15.7533 10.6533 11.5 15.9 11.5C21.1467 11.5 25.4 15.7533 25.4 21V36.1H20.9V20.95C20.9 18.1057 18.5943 15.8 15.75 15.8C12.9057 15.8 10.6 18.1057 10.6 20.95V36.1H6.39999V21Z",
    fill: "url(#paint7_linear_117_409)",
    stroke: "url(#paint8_linear_117_409)",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_117_409",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C214C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_117_409",
    x1: 29.9,
    y1: 13.5,
    x2: 29.9,
    y2: 38.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#61FEE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3A5ED4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_117_409",
    x1: 36.35,
    y1: 11.4,
    x2: 36.35,
    y2: 36.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3152B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#518CE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_117_409",
    x1: 21,
    y1: 23.8,
    x2: 40.2,
    y2: 23.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#48D8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C98FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_117_409",
    x1: 40.2,
    y1: 23.8,
    x2: 21,
    y2: 23.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AC3E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_117_409",
    x1: 15.2,
    y1: 13.5,
    x2: 15.2,
    y2: 36.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB1C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3C62D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_117_409",
    x1: 21.65,
    y1: 11.4,
    x2: 21.65,
    y2: 36.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E4DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4B82D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_117_409",
    x1: 15.9,
    y1: 11.4,
    x2: 15.9,
    y2: 36.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61FEE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#209EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_117_409",
    x1: 25.5,
    y1: 23.8,
    x2: 6.29999,
    y2: 23.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC4E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeross);
export default __webpack_public_path__ + "static/media/meross.8ccb3e50227e17acb4ec31327ef58a58.svg";
export { ForwardRef as ReactComponent };